
import { defaultZona, ZonaProps } from "./ZonaInterface";
import { CiudadProps, defaultCiudad } from "./CiudadInterface";
import { defaultEstado, EstadoProps } from "./EstadoInterface";
import { defaultMunicipio, MunicipioProps } from "./MunicipioInterface";
import { defaultTipoAsentamiento, TipoAsentamientoProps } from "./TipoAsentamientoInterface";

//Definición de defaults

export const defaultAsentamiento: AsentamientoProps = {
    idAsentamiento:         0,
    clave:                  '',
    descripcion:            '',
    codigoPostal:           '',
    idTipoAsentamiento:     0,
    tipoAsentamiento:       defaultTipoAsentamiento,
    idEstado:               0,
    estado:                 defaultEstado,
    idMunicipio:            0,
    municipio:              defaultMunicipio,
    idCiudad:               0,
    ciudad:                 defaultCiudad,
    activo:                 false,
    idZona:                 0,
    zona:                   defaultZona,
}

// Creación de interfaces

export interface AsentamientoProps {
    idAsentamiento:       number;
    clave:                string;
    descripcion:          string;
    codigoPostal:         string;
    idTipoAsentamiento:   number;
    tipoAsentamiento?:    TipoAsentamientoProps;
    idEstado:             number;
    estado?:              EstadoProps;
    idMunicipio:          number;
    municipio?:           MunicipioProps;
    idCiudad?:            number;
    ciudad?:              CiudadProps;
    activo:               boolean;
    idZona:               number;
    zona?:                ZonaProps;
}

export interface ActualizarAsentamientoProps {
    idAsentamiento:       number;
    activo:               boolean;
}

export interface ObtenerCodigosPostalesParams {
    codigoPostal:         string;
}

export interface ObtenerAsentamientoParams{
    idEstado:             number;
    idMunicipio:          number;
}

export interface AsentamientoParser {
    idAsentamiento:       number;    
    asentamiento:         string;
    codigoPostal:         string;
    tipo:                 string;
}

export interface AsentamientosResponse {
    records:          AsentamientoProps[];
    currentPageIndex: number;
    pageCount:        number;
    recordsCount:     number;
}
